import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isBooleanListField, isBooleanSingleField, isComponentListField, isComponentSingleField, isLocationListField, isLocationSingleField, isNumberListField, isNumberSingleField, isReferenceListField, isReferenceSingleField, isRichTextListField, isRichTextSingleField, isStringListField, isStringSingleField, } from '@dossierhq/core';
import { useContext } from 'react';
import { DossierContext } from '../../contexts/DossierContext.js';
import { AddBooleanListItemButton, BooleanFieldEditor } from './BooleanFieldEditor.js';
import { AddComponentListItemButton, ComponentFieldEditor } from './ComponentFieldEditor.js';
import { FieldListWrapper } from './FieldListWrapper.js';
import { AddLocationListItemButton, LocationFieldEditor } from './LocationFieldEditor.js';
import { AddNumberListItemButton, NumberFieldEditor } from './NumberFieldEditor.js';
import { AddEntityListItemButton, ReferenceFieldEditor } from './ReferenceFieldEditor.js';
import { AddRichTextListItemButton, RichTextFieldEditor } from './RichTextFieldEditor.js';
import { AddStringListItemButton, StringFieldEditor } from './StringFieldEditor.js';
export function FieldEditor(props) {
    const { fieldSpec, value } = props;
    const { adapter } = useContext(DossierContext);
    const overriddenEditor = adapter.renderFieldEditor(props);
    if (overriddenEditor) {
        return overriddenEditor;
    }
    let editor;
    if (isBooleanSingleField(fieldSpec, value)) {
        editor = (_jsx(BooleanFieldEditor, { ...props, fieldSpec: fieldSpec, value: value }));
    }
    else if (isBooleanListField(fieldSpec, value)) {
        editor = (_jsx(FieldListWrapper, { ...props, fieldSpec: fieldSpec, value: value, AddButton: AddBooleanListItemButton, Editor: BooleanFieldEditor }));
    }
    else if (isReferenceSingleField(fieldSpec, value)) {
        editor = (_jsx(ReferenceFieldEditor, { ...props, fieldSpec: fieldSpec, value: value }));
    }
    else if (isReferenceListField(fieldSpec, value)) {
        editor = (_jsx(FieldListWrapper, { ...props, fieldSpec: fieldSpec, value: value, AddButton: AddEntityListItemButton, Editor: ReferenceFieldEditor }));
    }
    else if (isLocationSingleField(fieldSpec, value)) {
        editor = (_jsx(LocationFieldEditor, { ...props, fieldSpec: fieldSpec, value: value }));
    }
    else if (isLocationListField(fieldSpec, value)) {
        editor = (_jsx(FieldListWrapper, { ...props, fieldSpec: fieldSpec, value: value, AddButton: AddLocationListItemButton, Editor: LocationFieldEditor }));
    }
    else if (isNumberSingleField(fieldSpec, value)) {
        editor = (_jsx(NumberFieldEditor, { ...props, fieldSpec: fieldSpec, value: value }));
    }
    else if (isNumberListField(fieldSpec, value)) {
        editor = (_jsx(FieldListWrapper, { ...props, fieldSpec: fieldSpec, value: value, AddButton: AddNumberListItemButton, Editor: NumberFieldEditor }));
    }
    else if (isRichTextSingleField(fieldSpec, value)) {
        editor = (_jsx(RichTextFieldEditor, { ...props, fieldSpec: fieldSpec, value: value }));
    }
    else if (isRichTextListField(fieldSpec, value)) {
        editor = (_jsx(FieldListWrapper, { ...props, fieldSpec: fieldSpec, value: value, AddButton: AddRichTextListItemButton, Editor: RichTextFieldEditor }));
    }
    else if (isStringSingleField(fieldSpec, value)) {
        editor = (_jsx(StringFieldEditor, { ...props, fieldSpec: fieldSpec, value: value }));
    }
    else if (isStringListField(fieldSpec, value)) {
        editor = (_jsx(FieldListWrapper, { ...props, fieldSpec: fieldSpec, value: value, AddButton: AddStringListItemButton, Editor: StringFieldEditor }));
    }
    else if (isComponentSingleField(fieldSpec, value)) {
        editor = (_jsx(ComponentFieldEditor, { ...props, fieldSpec: fieldSpec, value: value }));
    }
    else if (isComponentListField(fieldSpec, value)) {
        editor = (_jsx(FieldListWrapper, { ...props, fieldSpec: fieldSpec, value: value, AddButton: AddComponentListItemButton, Editor: ComponentFieldEditor }));
    }
    else {
        editor = _jsxs("div", { children: [`${fieldSpec.type} (list: ${!!fieldSpec.list})`, " is not supported"] });
    }
    return editor;
}
//# sourceMappingURL=FieldEditor.js.map